import { SendOTPDto } from '../../../dto/otp/sendotp/sendotpdto';
import { APIResponse, APIResponseDtoImpl } from '../../apiresponse';

export interface SendOTPResponse extends APIResponse 
{
    getSendOTPDto(): SendOTPDto;
}

export class SendOTPResponseDtoImpl extends APIResponseDtoImpl implements SendOTPResponse 
{
    private sendOTPRespnseDto : SendOTPDto;

    getSendOTPDto(): SendOTPDto
    {
        return this.sendOTPRespnseDto;
    }
    setSendOTPDto(sendOTPRespnseDto: SendOTPDto)
    {
        this.sendOTPRespnseDto = sendOTPRespnseDto;
    }
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/otp/sendotp/sendotpresponse.tsx